const isProd =
  process.env.REACT_APP_API_ENDPOINT === 'production' ||
  process.env.NODE_ENV === 'production';

const PAYTERNAL_CDN = isProd
  ? 'https://c.zmtcdn.com/web-payments-sdk/latest/checkout.js'
  : 'https://c.zmtcdn.com/web-payments-sdk/preprod/latest/checkout.js';

const SCRIPT_ID = 'payternal-sdk';
let loadPromise = null;

export function loadPayternalScript() {
  if (window.Payternal) return Promise.resolve();
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById(SCRIPT_ID);
    if (existing) {
      existing.addEventListener('load', resolve);
      existing.addEventListener('error', () => reject(new Error('Payternal SDK failed to load')));
      return;
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = PAYTERNAL_CDN;
    script.async = true;
    script.onload = resolve;
    script.onerror = () => {
      loadPromise = null;
      reject(new Error('Payternal SDK failed to load'));
    };
    document.body.appendChild(script);
  });

  return loadPromise;
}
